import styles from './sponsor-overlay.module.css'
import closeImg from '../../assets/gfx/close.svg'
import Tippaya_Logo from '../../assets/sponsor/Tippaya_Logo.webp';
import Kikine_Logo from '../../assets/sponsor/Kikine_Logo.webp';
import mcmc_Logo from '../../assets/sponsor/mcmc.webp';
import nanashi_Logo from '../../assets/sponsor/774-logo.webp';
import satan_Logo from '../../assets/sponsor/satan.webp';
import karou_Logo from '../../assets/sponsor/karou.webp';
import shrimin_Logo from '../../assets/sponsor/shrimin.webp';
import mocoright_Logo from '../../assets/sponsor/mocoright.webp';
import amiya_Logo from '../../assets/sponsor/amiya_logo.webp';
import miyataka_Logo from '../../assets/sponsor/miyataka.webp';


function SponsorOverlay({close, lang}) {
    const text = {
        JA: [
            "スポンサーを募集中！",
            "スポンサーになったらオリンが",
            "君オリジナルのロゴを作って",
            "カスタム当日配信画面とココに掲載するよ!",
            "(￥3000以上で作ります)"
        ],
        EN: [
            "Looking for sponsors!",
            "If you become a sponsor,",
            "Orin will create a logo",
            "for you and display it on this website!",
            "(Minimum ¥3000($20) per logo)"
        ]
    }

    return <div className={styles.wrapper}>
        <img width="128" onClick={close} src={closeImg} alt="close" className={styles.close} />
        <div className={styles.inner}>
            <div className={styles.title}>Sponsor</div>

            <div className={styles.content}>
                    <div className={`${styles['content-text-left']} `}>{text[lang][0]}</div>
                    <div className={`${styles['content-text-right']}`}>{text[lang][1]}</div>
                    <div className={`${styles['content-text-right']}`}>{text[lang][2]}</div>
                    <div className={`${styles['content-text-left']} `}>{text[lang][3]}</div>
                    <div className={`${styles['content-text-left']} `}>{text[lang][4]}</div>
            </div>
            <a
                    href="https://streamelements.com/yuusha_orin/tip"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
            >

                <div className={styles.content_2}>
                        <div className={styles['content-title']}>BE A SPONSOR!</div>
                        <div className={styles['content-subtitle']}>- スポンサーになる -</div>
                </div>
            </a>

            <div className={styles.content_3}>
                    <div className={styles['content-title-impact']}>Sponsor List</div>
                    <div className={styles.imgs}>
                        <img src={Tippaya_Logo} className={styles.SponsorList} alt="more" />
                        <img src={Kikine_Logo} className={styles.SponsorList} alt="more" />
                        <img src={mcmc_Logo} className={styles.SponsorList} alt="more" />
                        <img src={nanashi_Logo} className={`${styles.SponsorList} ${styles.nanashi}`} alt="nanashi" />
                        <img src={satan_Logo} className={`${styles.SponsorList} ${styles.satan}`} alt="satan" />
                        <img src={karou_Logo} className={styles.SponsorList} alt="more" />
                        <img src={shrimin_Logo} className={styles.SponsorList} alt="more" />
                        <img src={mocoright_Logo} className={styles.SponsorList} alt="more" />
                        <img src={amiya_Logo} className={styles.SponsorList} alt="more" />
                        <img src={miyataka_Logo} className={`${styles.SponsorList} ${styles.miyataka}`} alt="miyataka" />
                    </div>

            </div>

        </div>

    </div>;
}

export default SponsorOverlay;